<span class="badge" [class]="variant()">
  @if (dot()) {
    <span class="dot"></span>
  }
  {{ label() }}
</span>
